import { render, staticRenderFns } from "./ChatbotManuals.vue?vue&type=template&id=53bffcce&scoped=true"
import script from "./ChatbotManuals.vue?vue&type=script&lang=js"
export * from "./ChatbotManuals.vue?vue&type=script&lang=js"
import style0 from "./ChatbotManuals.vue?vue&type=style&index=0&id=53bffcce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bffcce",
  null
  
)

export default component.exports